module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Tags":"Tags","Add tag":"Tag hinzufügen"}}')
  delete Component.options._Ctor
}
